import { GA4FrontPageEvent } from "../content/frontpage-analytics";
import { BaseGA4FeedbackEvent } from "../content/feedback-analytics";
import {
  GA4ContactFormEvent,
  GA4FormStartEvent,
  GA4LeadFormEvent,
  GA4NewsLetterEvent,
} from "../content/form-analytics";
import { BaseGA4MenuEvent } from "../content/menu-analytics";

import { GA4FAQEvent } from "../content/faq-analytics";
import { BaseGA4FunnelTracking } from "../content/funnel-analytics";
import { BaseGA4LoginData } from "../content/login-analytics";
import { GA4PhoneClickEvent } from "../content/phone-analytics";
import { BaseGA4MbbEvent } from "../ecommerce/mbb/b2c/mbb-b2c-analytics.models";
import { BaseEcommerceAddonEvent } from "../ecommerce/voice/voice-addon-analytics";
import { GA4B2BSubscriptionEvent } from "../ecommerce/mbb/b2b/mbb-b2b-analytics";
import {
  GA4SubscriptionCardEvent,
  GA4SubscriptionPromoBannerEvent,
  GA4SubscriptionToggleEvent,
} from "../content/subscription-analytics";
import { GA4SearchClickEvent, GA4SearchResultsClickEvent } from "../content/search-analytics";
import {
  GA4GoToCheckoutButtonClick,
  GA4HardwareSelectItemEvent,
  GA4OrderingButtonClick,
} from "@shared/Analytics/ecommerce/voice/voice-analytics-types";
import { GA4CustomerService } from "@shared/Analytics/content/customer-service-analytics";

export const clearPreviousEcommerceObjectToDataLayer = (): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
};

type BaseDataLayerEvents =
  | BaseEcommerceAddonEvent
  | BaseGA4FeedbackEvent
  | BaseGA4FunnelTracking
  | BaseGA4LoginData
  | BaseGA4MbbEvent
  | BaseGA4MenuEvent
  | GA4B2BSubscriptionEvent
  | GA4ContactFormEvent
  | GA4CustomerService
  | GA4FAQEvent
  | GA4FormStartEvent
  | GA4FrontPageEvent
  | GA4GoToCheckoutButtonClick
  | GA4HardwareSelectItemEvent
  | GA4LeadFormEvent
  | GA4NewsLetterEvent
  | GA4OrderingButtonClick
  | GA4PhoneClickEvent
  | GA4SearchClickEvent
  | GA4SearchResultsClickEvent
  | GA4SubscriptionCardEvent
  | GA4SubscriptionPromoBannerEvent
  | GA4SubscriptionToggleEvent;

export const pushToDataLayer = (event: BaseDataLayerEvents): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};
